import Backbone from 'backbone';

export default Backbone.Model.extend({
	url: function() {
		return '/services/selectlanguage/' + this.get('languageId');
	}
});
